import dynamic from "next/dynamic";

export const FormSideImages = dynamic(() => import("./component"));
